import { createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = {
    id: "alert-dialog",
    class: "alert-dialog"
};
const _hoisted_2 = { method: "dialog" };
const _hoisted_3 = {
    id: "alert-title",
    class: "title"
};
const _hoisted_4 = { class: "main-container" };
const _hoisted_5 = { class: "notice" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_StartScreen = _resolveComponent("StartScreen");
    const _component_CreateGameForm = _resolveComponent("CreateGameForm");
    const _component_LoadGameForm = _resolveComponent("LoadGameForm");
    const _component_GameHome = _resolveComponent("GameHome");
    const _component_PlayerHome = _resolveComponent("PlayerHome");
    const _component_SpectatorHome = _resolveComponent("SpectatorHome");
    const _component_GameEnd = _resolveComponent("GameEnd");
    const _component_GamesOverview = _resolveComponent("GamesOverview");
    const _component_CardList = _resolveComponent("CardList");
    const _component_AdminHome = _resolveComponent("AdminHome");
    const _component_LoginHome = _resolveComponent("LoginHome");
    const _component_Help = _resolveComponent("Help");
    const _directive_i18n = _resolveDirective("i18n");
    return (_openBlock(), _createElementBlock("div", {
        class: _normalizeClass('topmost-' + _ctx.screen)
    }, [
        _createElementVNode("section", null, [
            _createElementVNode("dialog", _hoisted_1, [
                _createElementVNode("form", _hoisted_2, [
                    _withDirectives((_openBlock(), _createElementBlock("p", _hoisted_3, [...(_cache[0] || (_cache[0] = [
                            _createTextVNode("Error with input", -1)
                        ]))])), [
                        [_directive_i18n]
                    ]),
                    _cache[1] || (_cache[1] = _createElementVNode("p", { id: "alert-dialog-message" }, null, -1)),
                    _cache[2] || (_cache[2] = _createElementVNode("menu", { class: "dialog-menu centered-content" }, [
                        _createElementVNode("button", {
                            id: "alert-dialog-button",
                            class: "btn btn-lg btn-primary"
                        }, "OK")
                    ], -1))
                ])
            ])
        ]),
        _createElementVNode("div", _hoisted_4, [
            (_ctx.screen === 'start-screen')
                ? (_openBlock(), _createBlock(_component_StartScreen, { key: 0 }))
                : (_ctx.screen === 'create-game-form')
                    ? (_openBlock(), _createBlock(_component_CreateGameForm, { key: 1 }))
                    : (_ctx.screen === 'load')
                        ? (_openBlock(), _createBlock(_component_LoadGameForm, { key: 2 }))
                        : (_ctx.screen === 'game-home' && _ctx.game !== undefined)
                            ? (_openBlock(), _createBlock(_component_GameHome, {
                                key: 3,
                                game: _ctx.game
                            }, null, 8, ["game"]))
                            : (_ctx.screen === 'player-home' && _ctx.playerView !== undefined)
                                ? (_openBlock(), _createBlock(_component_PlayerHome, {
                                    "player-view": _ctx.playerView,
                                    key: _ctx.playerkey
                                }, null, 8, ["player-view"]))
                                : (_ctx.screen === 'spectator-home' && _ctx.spectator !== undefined)
                                    ? (_openBlock(), _createBlock(_component_SpectatorHome, {
                                        spectator: _ctx.spectator,
                                        key: 'spectator-' + _ctx.playerkey
                                    }, null, 8, ["spectator"]))
                                    : (_ctx.screen === 'the-end')
                                        ? (_openBlock(), _createBlock(_component_GameEnd, {
                                            key: 6,
                                            "player-view": _ctx.playerView,
                                            spectator: _ctx.spectator
                                        }, null, 8, ["player-view", "spectator"]))
                                        : (_ctx.screen === 'games-overview')
                                            ? (_openBlock(), _createBlock(_component_GamesOverview, { key: 7 }))
                                            : (_ctx.screen === 'cards')
                                                ? (_openBlock(), _createBlock(_component_CardList, { key: 8 }))
                                                : (_ctx.screen === 'admin')
                                                    ? (_openBlock(), _createBlock(_component_AdminHome, { key: 9 }))
                                                    : (_ctx.screen === 'login-home')
                                                        ? (_openBlock(), _createBlock(_component_LoginHome, { key: 10 }))
                                                        : (_ctx.screen === 'help')
                                                            ? (_openBlock(), _createBlock(_component_Help, { key: 11 }))
                                                            : _createCommentVNode("", true)
        ]),
        _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_5, [...(_cache[3] || (_cache[3] = [
                _createTextVNode(" Not affiliated with FryxGames, Asmodee Digital or Steam in any way. ", -1)
            ]))])), [
            [_directive_i18n]
        ])
    ], 2));
}
